export default __webpack_public_path__ + "static/media/startlater_3.cb61be93.jpg";